import { fetchPaintings } from '@/services/sheets'

export default {
    namespaced: true,

    state: () => ({
        items: [],
        loading: false,
        loaded: false,
    }),

    getters: {
        all: state => state.items,
        featured: state => state.items.filter(p => p.isFeatured),
        available: state => state.items.filter(p => p.isAvailable),

        byTag: state => tag => {
            if (!tag || tag === 'all') return state.items
            return state.items.filter(p => p.tags.includes(tag))
        },

        byId: state => id => state.items.find(p => p.id === id),

        allTags: state => {
            const counts = {}
            state.items.forEach(p => {
                p.tags.forEach(t => { counts[t] = (counts[t] || 0) + 1 })
            })
            return Object.entries(counts)
                .map(([name, count]) => ({ name, count }))
                .sort((a, b) => b.count - a.count)
        },
    },

    mutations: {
        SET_ITEMS(state, items) { state.items = items },
        SET_LOADING(state, val) { state.loading = val },
        SET_LOADED(state, val) { state.loaded = val },
    },

    actions: {
        async fetch({ commit, state }) {
            if (state.loaded) return
            commit('SET_LOADING', true)
            try {
                const data = await fetchPaintings()
                commit('SET_ITEMS', data)
                commit('SET_LOADED', true)
            } catch (e) {
                console.error('[Store:paintings]', e)
            } finally {
                commit('SET_LOADING', false)
            }
        }
    }
}
